/**
 * 연봉협상일 표시 — wit_organization_user.negotiation_date 는 연도 없는 'MM-DD' 문자열이다.
 * new Date('10-15') 처럼 날짜로 변환하면 Invalid Date가 되므로 문자열을 그대로 해석해 'N월 N일'로 표시한다.
 * @param {string} monthDay 'MM-DD'
 * @returns {string} 'N월 N일' (형식이 다르면 원본 그대로, 값이 없으면 빈 문자열)
 */
export const formatMonthDay = (monthDay) => {
    if (!monthDay) return '';
    const m = /^(\d{1,2})-(\d{1,2})$/.exec(String(monthDay).trim());
    if (!m) return String(monthDay);
    return `${parseInt(m[1], 10)}월 ${parseInt(m[2], 10)}일`;
};
